export const maxByteLength = (byteLength: number) => (val: string) =>
    new TextEncoder().encode(val).byteLength <= byteLength
